import { ContextStore } from '../stores';
import { initAppendContextData } from './append-context-data';
import { appendUserAgentData } from './append-user-agent-data';
import { initEnvironmentDataTransformer } from './environment-data';
import { EnvironmentOptions } from '../validation/schemas';

const initEnrichEvent = ({ environment, contextStore }: { environment: EnvironmentOptions; contextStore: ContextStore }) => {
  const appendEnvironmentData = initEnvironmentDataTransformer(environment);
  const appendContextData = initAppendContextData(contextStore);
  return <T>(input: T): T => {
    const withUserAgentData = appendUserAgentData(input);
    const andEnvironmentData = appendEnvironmentData(withUserAgentData);
    return appendContextData(andEnvironmentData);
  };
};

export default initEnrichEvent;
